import { PATH_HOME } from "./paths";

export function flightsItineraryRelativeRoute(itineraryId: string) {
  return itineraryId;
}

export function flightsItineraryAbsoluteRoute(itineraryId: string) {
  return `${PATH_HOME}${flightsItineraryRelativeRoute(itineraryId)}`;
}

export function cfarFlightsExerciseRelativeRoute() {
  return `cfar`;
}
